<template>
  <v-container>
    <FirstSushiHelpWidget />
  </v-container>
</template>

<script>
import FirstSushiHelpWidget from "@/components/help/FirstSushiHelpWidget";
export default {
  name: "IntroPage",
  components: { FirstSushiHelpWidget },
};
</script>

<style scoped></style>
